import { FormEvent, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import Input from "../../../../../../components/Input";
import InputSelect from "../../../../../../components/Input-select";
import Spinner from "../../../../../../components/Spinner";
import { toastError, toastSuccess } from "../../../../../../components/Toast";
import useAuthData from "../../../../../../hook/useAppData";
import { data } from "../../Form/constants";
import { IEletronicInventory } from "../../Form/models";
import { getEletronicById, putEletronic } from "../../service";
import { SelectModal } from "../constants";
import useListEletronicStore from "../store/useStore";

export function ModalDeleteContent(props) {
  const { token } = useAuthData();
  const { modalStatus } = useListEletronicStore();
  const { setModalStatus, getEletronics } = useListEletronicStore();
  const [selectValue, setSelectValue] = useState(0);
  const [defaultValues, setDefaultValues] = useState(data as IEletronicInventory);
  const [needSpinnerModal, setNeedSpinnerModal] = useState(true);
  const setNameItem = props.setNameItem;

  useEffect(() => {
    getEletronicsById();
  }, []);

  useEffect(() => {
    setNeedSpinnerModal(false);
  }, [defaultValues]);

  async function getEletronicsById() {
    const data = await getEletronicById(token, modalStatus.id);
    const dataTrated: IEletronicInventory = {
      ...data,
      observation: "",
    };
    if (dataTrated?.status === "Doado") setSelectValue(1);
    if (dataTrated?.status === "Vendido") setSelectValue(2);
    setNameItem(dataTrated?.nameProduct);
    setDefaultValues(dataTrated);
  }

  function saveDataOfField(event) {
    let { value, name } = event;
    setDefaultValues({ ...defaultValues, [`${name}`]: value });
  }

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (selectValue != 1 && selectValue != 2) return toastError("Status não selecionado");
    const data = {
      ...defaultValues,
      isDeleted: true,
      status: verifyValueSelect(),
    };
    updateData(data);
  }

  async function updateData(data) {
    const res = await putEletronic({ data }, token, modalStatus.id);
    verifyRes(res);
  }

  function verifyRes(res) {
    if (!res.ok) return toastError("erro ao inativar");
    toastSuccess(`item ${verifyValueSelect()}, este item foi inativado!`);
    setTimeout(() => {
      getEletronics(token);
      return setModalStatus({ status: false, id: 0 });
    }, 1000);
  }

  function verifyValueSelect() {
    if (selectValue == 1) return "Doado";
    if (selectValue == 2) return "Vendido";
  }

  return (
    <>
      <Toaster />
      <form onSubmit={handleSubmit} className="box-form min-height-none">
        <Spinner status={needSpinnerModal} classNameFather="modal-spinner-width">
          <div className="div-input-modal">
            <Input
              className="input-modal-eletronic"
              name="observation"
              label="Digite uma Observação"
              placeholder="Observação"
              value={defaultValues?.observation}
              setValue={(event) => saveDataOfField(event.target)}
            />
            <InputSelect
              className="form-input inputContainer teste45 field-history select-modal-eletronic"
              name="status"
              label="Status"
              placeholder="Status"
              value={selectValue}
              onChange={(event: any) => setSelectValue(event.target.value)}
              list={SelectModal}
            />
          </div>
          <div className="flex btnContainer div-btn-modal-eletronic justify-start width-100 ">
            <button type="submit" className="btn filter-btn history-filter-btn">
              Salvar
            </button>
            <button className="Link btn bg-secondary history-filter-btn" onClick={() => setModalStatus({ status: false, id: 0 })}>
              Cancelar
            </button>
          </div>
        </Spinner>
      </form>
    </>
  );
}
